import {
  FONT_WEIGHT_KEYWORD,
  FontWeights,
} from 'app/pages/admin/landing-pages-v2/constants';
import { FontFamilyOption } from 'app/pages/design/landingPageBuilder/components';
import { weightMap } from './generateFontFaces';

interface IGetFilteredFontWeightsParams {
  fontFamilyValue: string | null;
  fontWeightValue?: FONT_WEIGHT_KEYWORD | null;
  allFontFamilyOptions: FontFamilyOption[];
}

export const getFilteredFontWeights = ({
  fontFamilyValue,
  fontWeightValue,
  allFontFamilyOptions,
}: IGetFilteredFontWeightsParams) => {
  if (!fontFamilyValue) {
    return {
      filteredFontWeights: [],
      fallbackWeight: null,
    };
  }
  const variants =
    allFontFamilyOptions.find(font => font.value === fontFamilyValue)
      ?.variants || [];

  const filteredVariants = variants
    .filter(variant => variant && !variant.toLowerCase().includes('italic'))
    .map(variant => weightMap?.[variant])
    .filter(Boolean);

  const filteredFontWeights = FontWeights.filter(weight =>
    filteredVariants.includes(Number(weight.value))
  );

  const currentWeight = fontWeightValue
    ? weightMap[fontWeightValue.toLowerCase()]
    : undefined;

  let fallbackWeight: string | undefined;

  const regularWeight = filteredFontWeights.find(w => w.value === '400');

  if (!currentWeight || !filteredVariants.includes(currentWeight)) {
    // No current weight OR invalid weight — fallback to 400 or first available
    fallbackWeight = regularWeight?.value || filteredFontWeights[0]?.value;
  } else {
    // Current weight is valid
    fallbackWeight = currentWeight.toString();
  }

  return {
    filteredFontWeights,
    fallbackWeight,
  };
};
